import { CircleAlert } from 'lucide-react'

import { cn } from '#components/utils.js'

export function ErrorAlert({
  children,
  className,
  title = 'Unable to continue',
}) {
  return (
    <div
      className={cn(
        'grid w-full grid-cols-[1rem_1fr] gap-x-3 rounded-md border border-destructive/35 bg-destructive/5 px-4 py-3 text-sm text-destructive',
        className,
      )}
      data-slot='error-alert'
      role='alert'
    >
      <CircleAlert aria-hidden='true' className='mt-0.5 size-4' />
      <div>
        <p className='font-medium'>{title}</p>
        <div className='mt-1 leading-6 text-foreground/75'>{children}</div>
      </div>
    </div>
  )
}
